export const listOptions: CSSFunction = () => ({
  listStyleType: 'disc',
  margin: '0px',
  marginLeft: '16px',
});
